var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrow = function SvgArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66537 1.69613L4.30795 4.91293C4.20248 5.00082 4.09701 5.03598 4.00912 5.03598C3.90365 5.03598 3.79818 5.00082 3.71029 4.93051L0.335292 1.69613C0.159511 1.53793 0.159511 1.25668 0.317714 1.09848C0.475917 0.922694 0.757167 0.922694 0.91537 1.0809L4.00912 4.03402L7.08529 1.0809C7.24349 0.922694 7.52474 0.922694 7.68295 1.09848C7.84115 1.25668 7.84115 1.53793 7.66537 1.69613Z",
    fill: "#475467"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow.e95eb5349cf6b62ee09df863e0adfc8b.svg";